import { createRouter, createWebHistory } from 'vue-router'

import Home from '../views/homeView.vue'
import Stor from '../views/storView.vue'
import Tul from '../views/tulView.vue'
import Fon from '../views/fonView.vue'
import Ceyiz from '../views/ceyizView.vue'

const routes = [
  { path: '/', component: Home },
  { path: '/stor', component: Stor },
  { path: '/tul', component: Tul },
  { path: '/fon', component: Fon },
  { path: '/ceyiz', component: Ceyiz }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router